import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

export const TableWrapper = styled.div`
  overflow: hidden;
  border-radius: ${theme.shapes.borderRadius.sm};
`
export const SizesTable = styled.table`
  thead {
    background-color: #f8f8f8;
  }

  tbody {
    background-color: ${theme.colors.neutral.white};
  }

  td {
    height: 32px;
    padding: 0 ${theme.spacing.sm};

    text-align: center;
    font-family: ${theme.typography.family.primary};
    font-size: ${theme.typography.sizes['2xs']};
    color: ${theme.colors.neutral.black};
  }
`

export const InfoIcon = styled(InfoOutlinedIcon)`
  color: ${theme.colors.primary.main};
  width: ${theme.icon.size.small};
  height: ${theme.icon.size.small};
`
